import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import ForumIcon from '@mui/icons-material/Forum';
import WorkIcon from '@mui/icons-material/Work';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useAuth } from '../context/AuthContext';
import { useThemeMode } from '../App';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const { mode, toggleMode } = useThemeMode();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    logout();
    navigate('/login');
  };

  const handleProfile = () => {
    handleClose();
    navigate('/profile');
  };

  return (
    <Box>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Manager Telegram
          </Typography>
          <Button
            color="inherit"
            onClick={() => navigate('/dashboard')}
            sx={{ mr: 1 }}
            startIcon={<DashboardIcon />}
          >
            Панель
          </Button>
          {user?.role === 'admin' && (
            <Button
              color="inherit"
              onClick={() => navigate('/users')}
              sx={{ mr: 1 }}
              startIcon={<PeopleIcon />}
            >
              Пользователи
            </Button>
          )}
          <Button
            color="inherit"
            onClick={() => navigate('/projects')}
            sx={{ mr: 1 }}
            startIcon={<WorkIcon />}
          >
            Проекты
          </Button>
          <Button
            color="inherit"
            onClick={() => navigate('/messages')}
            sx={{ mr: 1 }}
            startIcon={<ForumIcon />}
          >
            Сообщения
          </Button>
          <IconButton
            color="inherit"
            onClick={toggleMode}
            sx={{ ml: 1 }}
            aria-label="Переключить тему"
          >
            {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
          <IconButton
            color="inherit"
            onClick={handleClick}
            sx={{ ml: 1 }}
            aria-label="Меню пользователя"
            aria-controls={open ? 'user-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <PersonIcon />
          </IconButton>
          <Menu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'user-menu-button',
            }}
          >
            <MenuItem disabled>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {user?.username}
              </Typography>
            </MenuItem>
            <MenuItem disabled>
              <Typography variant="caption" color="text.secondary">
                {user?.role === 'super_admin' ? 'Супер Админ' : user?.role === 'admin' ? 'Админ' : 'Сотрудник'}
              </Typography>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleProfile}>
              <PersonIcon sx={{ mr: 1, fontSize: 20 }} />
              Профиль
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <LogoutIcon sx={{ mr: 1, fontSize: 20 }} />
              Выход
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      {children}
    </Box>
  );
};

export default Layout;
